import type { RootState } from 'state';
import type { FlightsCalendarsFiltersOptionsState } from '../slice';

function getAirportsFrom(state: RootState): FlightsCalendarsFiltersOptionsState['airportsFrom'] {
  const { airportsFrom } = state.flightCalendars.filtersOptions;
  return airportsFrom;
}

export default getAirportsFrom;
